import { useSearchParams } from "react-router-dom";
import styles from "./style.module.scss";
import { http } from "../../api/utils/http";
import { approveUserByIdentifier } from "../../api/config";
import { useEffect, useState } from "react";

/**
 * This component can be used for user approval redirection
 * This page takes identifier from query and sends to backend for approval
 */
const ApproveUser = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const handleApproveApiRequest = () => {
    // Make request to approve user
    http.makePostRequest<unknown, { message: string }>(
      approveUserByIdentifier,
      () => {
        setLoading(false);
      },
      (error) => {
        setLoading(false);

        if (error?.response?.data?.message) {
          setError(error?.response?.data?.message);
        }
      },
      {
        identifier: searchParams.get("identifier"),
      }
    );
  };

  useEffect(() => {
    handleApproveApiRequest();
  }, []);

  return (
    <div className={styles.container}>
      {loading ? (
        <>
          <h2>Your request is being processed</h2>
          <p>Please wait while we approve the user</p>
        </>
      ) : (
        <>
          <h2>{error ? "Error" : "Successful"}</h2>
          <p>{error ? error : "User is approved successfully"}</p>
        </>
      )}
    </div>
  );
};

export default ApproveUser;
